<template>
  <div class="d-flex flex-column align-items-center open-access-wrapper">
    <CHeader :fixed="true" class="py-3 c-header h-auto">
      <img src="/img/logo-galileo-color-2x.png" alt="logo" class="mz-logo" />
    </CHeader>
    <div
      class="d-flex flex-column align-items-center pt-5 m-auto"
      style="max-width: 1220px"
    >
      <CCard class="pt-2 mt-5">
        <CCardBody class="text-justify">
          <h2>{{ $t(`privacy_heading${suffix}`) }}</h2>
          <span v-html="$t(privacyPolicyKey)" v-if="$te(privacyPolicyKey)" />
        </CCardBody>
      </CCard>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  computed: {
    formId() {
      return this.$route.query.form_id
    },
    suffix() {
      return this.formId !== "1" ? `_${this.formId}` : "";
    },
    privacyPolicyKey() {
      return `privacy_policy${this.suffix}`;
    },
  },
};
</script>

<style lang="scss">
.mz-logo {
  height: 50px;
  object-fit: contain;
}
</style>
